import { toast } from "react-hot-toast";
import { apiConnector } from '../apiConnector';
import { gallaryEndpoints } from '../apis';

export const createGallery = async (formData) => {
    const toastId = toast.loading("Creating gallery...");
    let result = null;
    try {
        const response = await apiConnector("POST", gallaryEndpoints.CREATE_GALLERY_API, formData);

        if (!response?.success) {
            throw new Error("Could not create gallery");
        }

        result = response;
        toast.success("Gallery created successfully");
    } catch (error) {
        console.log("CREATE GALLERY API ERROR....", error);
        toast.error(error.message || 'Failed to create gallery');
        result = { success: false, message: error.message };
    }
    toast.dismiss(toastId);
    return result;
};


export const getAllGalleries = async () => {
    const toastId = toast.loading("Loading galleries...");
    let result = [];
    try {
        const response = await apiConnector("GET", gallaryEndpoints.GET_ALL_GALLERIES_API);

        if (!response?.data?.success) {
            throw new Error("Could not fetch galleries");
        }

        result = response.data;
    } catch (error) {
        console.log("GET ALL GALLERIES API ERROR....", error);
        toast.error(error.message);
        result = error.response?.data;
    }
    toast.dismiss(toastId);
    return result;
};

export const updateGallery = async (id, formData) => {
    const toastId = toast.loading("Updating gallery...");
    let result = null;
    try {
        const response = await apiConnector("PUT", gallaryEndpoints.UPDATE_IMAGE_API(id), formData);

        if (!response?.data?.success) {
            throw new Error("Could not update gallery");
        }

        result = response.data;
        toast.success("Gallery updated successfully");
    } catch (error) {
        console.log("UPDATE GALLERY API ERROR....", error);
        toast.error(error.message);
        result = error.response?.data;
    }
    toast.dismiss(toastId);
    return result;
};

export const deleteGallery = async (id) => {
    const toastId = toast.loading("Deleting gallery...");
    let result = null;
    try {
        const response = await apiConnector("DELETE", gallaryEndpoints.DELETE_IMAGE_API(id));

        if (!response?.data?.success) {
            throw new Error("Could not delete gallery");
        }

        result = response.data;
       
    } catch (error) {
        console.log("DELETE GALLERY API ERROR....", error);
        toast.error(error.message);
        result = error.response?.data;
    }
    toast.dismiss(toastId);
    return result;
};
